import React, {memo, useMemo} from 'react';
import Util from '../../../../Util';
import AccountStore from '../../../../stores/AccountStore';
import {StyleSheet, View} from 'react-native';
import AVText from '../../../elements/AVText';

export const ProductInfo = memo(
  ({name, price}: {name: string; price: string | number}) => {
    const formattedPrice = useMemo(
      () => Util.formatCurrency(null, +price, AccountStore.getCurrency()),
      [price],
    );

    return (
      <View style={styles.productInfoWrapper}>
        <AVText style={styles.productNameText}>{name}</AVText>
        <AVText style={styles.productPriceText}>{formattedPrice}</AVText>
      </View>
    );
  },
);

const styles = StyleSheet.create({
  productInfoWrapper: {
    gap: 8,
    marginTop: 16,
  },
  productNameText: {
    fontWeight: '700',
    fontSize: 16,
    lineHeight: 19,
  },
  productPriceText: {
    fontWeight: '400',
    fontSize: 16,
    lineHeight: 19,
  },
});
ProductInfo.displayName = 'ProductInfo';
